import React from "react";
import Navbar from "../../components/navigation/web/Navbar";
import { FormSimulation } from "../../components/Simulation/FormSimulation";
import { useTranslation } from "react-i18next";

const ModifySimulation = () => {
	const { t } = useTranslation();
	return (
		<>
			<Navbar
				view={{
					title: t("sim.title"),
					component: (
						<>
							<FormSimulation />
						</>
					),
				}}
				right={null}
			/>
		</>
	);
};

export { ModifySimulation };
